const initialState = {
    stores: [],
    banners: [],
};
const home = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LIST_STORES_PAGE_HOME':
            return {...state, stores: action.stores};
        case 'SET_DATA_STORES_PAGE_HOME':
            return {...state, [action.name]: [action.value]};
        default:
            return state;
    }
};

export default home;
